/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { useResizeObserver } from "@react-aria/utils";
import { useRef, useState, type ReactNode } from "react";

import { cssFns } from "@superweb/css";
import { Button, useIsMobile, useTypo, useUiColors } from "@superweb/ui";

export const SubmitBottomSheet = ({
  isLoading,
  text,
  children,
}: {
  isLoading: boolean;
  text: string;
  children?: ReactNode;
}) => {
  const uiColors = useUiColors();
  const bottomSheetRef = useRef<HTMLDivElement>(null);
  const typo = useTypo();
  const isMobile = useIsMobile();

  const [bottomSheetHeight, setBottomSheetHeight] = useState<number>(0);

  useResizeObserver({
    ref: bottomSheetRef,
    onResize: () => {
      setBottomSheetHeight(bottomSheetRef.current?.clientHeight ?? 0);
    },
  });

  return (
    <>
      <div
        css={{
          height: `${bottomSheetHeight}px`,
        }}
      />
      <div
        ref={bottomSheetRef}
        css={{
          position: "absolute",
          bottom: "18px",
          insetInlineStart: "8px",
          width: "calc(100% - 16px)",
          display: "grid",
          gridTemplateColumns: "1fr",
        }}
      >
        <Button
          variant="action"
          type="submit"
          shape="squircle"
          progress={isLoading}
          text={text}
        />
        {children ? (
          <div
            css={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ...(isMobile
                ? cssFns.padding("8px", "0")
                : cssFns.padding("4px", "16px")),
              marginBlockEnd: "-18px",
              minHeight: "48px",
              textAlign: "center",
            }}
          >
            <div
              css={{
                ...typo({
                  level: "caption1",
                  weight: "regular",
                  density: "tight",
                }),
                color: uiColors.text,
              }}
            >
              {children}
            </div>
          </div>
        ) : undefined}
      </div>
    </>
  );
};
